import { render, staticRenderFns } from "./paymentFailed.vue?vue&type=template&id=705f2525&scoped=true"
import script from "./paymentFailed.vue?vue&type=script&lang=js"
export * from "./paymentFailed.vue?vue&type=script&lang=js"
import style0 from "./paymentFailed.vue?vue&type=style&index=0&id=705f2525&prod&scoped=true&lang=css"
import style1 from "./paymentFailed.vue?vue&type=style&index=1&id=705f2525&prod&scoped=true&lang=css"
import style2 from "./paymentFailed.vue?vue&type=style&index=2&id=705f2525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f2525",
  null
  
)

export default component.exports